<template>
  <div class="home">
    <div class="row">
      <div class="notify" v-if="notify.length">
        <div class="inner">
          <div class="mq" ref="notify_mq">
            <ul ref="notify_ul">
              <li v-for="item in notify" :key="item.id">
                <em class="txt">{{item.user.name}} {{item.remark}}</em>
                <em v-if="item.action === 1" class="credit plus">积分 +{{item.credits}}</em>
                <em v-else class="credit reduce">积分 {{item.credits}}</em>
                <em class="time">{{parseTime(item.createdAt)}}</em>
              </li>
            </ul>
            <ul v-if="notify.length > 5">
              <li v-for="index in 5" :key="notify[index - 1].id">
                <em class="txt">{{notify[index - 1].user.name}} {{notify[index - 1].remark}}</em>
                <em v-if="notify[index - 1].action === 1" class="credit plus">积分 +{{notify[index - 1].credits}}</em>
                <em v-else class="credit reduce">积分 {{notify[index - 1].credits}}</em>
                <em class="time">{{parseTime(notify[index - 1].createdAt)}}</em>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <h2>个人排行榜</h2>
      <el-table class="ranking" stripe :data="rankingUserCredit">
        <el-table-column
          width="160"
          align="center"
          type="index"
          label="排名">
          <template slot-scope="scope">
            <i :class="`icon-num${scope.$index + 1}`" v-if="scope.$index < 3"></i>
            <span v-else>{{scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="姓名">
        </el-table-column>
        <el-table-column
          prop="email"
          width="300"
          label="邮箱">
        </el-table-column>
        <el-table-column
          label="一级部门">
          <template slot-scope="scope">
            {{getFirstDepartment(scope.row.department_id)}}
          </template>
        </el-table-column>
        <el-table-column
          width="180"
          prop="sum"
          align="center"
          label="获得积分数">
        </el-table-column>
        <el-table-column
          align="center"
          width="180"
          label="积分详情">
          <template slot-scope="scope">
            <span class="btn-view-detail" :data-email="scope.row.email" @click="handleShowCreditPanel">积分详情</span>
          </template>
        </el-table-column>
      </el-table>
      <h2>一级部门排行榜</h2>
      <el-table class="ranking" stripe :data="rankingFirstDepartmentCredit">
        <el-table-column
          width="280"
          align="center"
          type="index"
          label="排名">
          <template slot-scope="scope">
            <i :class="`icon-num${scope.$index + 1}`" v-if="scope.$index < 3"></i>
            <span v-else>{{scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="department_name"
          label="部门名称">
        </el-table-column>
        <el-table-column
          prop="avg_credits"
          align="center"
          label="平均获得积分">
        </el-table-column>
        <el-table-column
          prop="sum_credits"
          align="center"
          label="获得积分总数">
        </el-table-column>
      </el-table>
      <h2>二级部门排行榜</h2>
      <el-table class="ranking" stripe :data="rankingDepartmentCredit">
        <el-table-column
          width="280"
          align="center"
          type="index"
          label="排名">
          <template slot-scope="scope">
            <i :class="`icon-num${scope.$index + 1}`" v-if="scope.$index < 3"></i>
            <span v-else>{{scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="department_name"
          label="部门名称">
        </el-table-column>
        <el-table-column
          prop="avg_credits"
          align="center"
          label="平均获得积分">
        </el-table-column>
        <el-table-column
          prop="sum_credits"
          align="center"
          label="获得积分总数">
        </el-table-column>
      </el-table>
    </div>
    <div class="credit-panel" v-if="creditPanelVisible">
      <div class="content" v-if="creditRecordList.length">
        <p :class="item.action === 1 ? 'p-plus' : 'p-reduce'" v-for="item in creditRecordList" :key="item.id">
          <span class="remark">{{item.remark}}</span>
          <span class="credit plus" v-if="item.action === 1">+{{item.credits}}</span>
          <span class="credit reduce" v-else>-{{item.credits}}</span>
          <span class="time" :title="formatDateLocal(new Date(item.createdAt))">{{formatDateStr(new Date(item.createdAt))}}</span>
        </p>
      </div>
      <div class="content" v-else>
        <div class="empty-wrap">
          <i class="icon-empty"></i>
          <span>还没有积分记录呀~</span>
        </div>
      </div>
      <div class="ft">
        <span class="btn-close" @click="handleCloseCreditPanel">关闭</span>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import API from '@/apis'
import { formatDateLocal, formatDateStr } from '../utils/datetime'

export default {
  name: 'home',
  mounted () {
    this.fetchData()
  },
  data () {
    return {
      now: new Date(),
      duration: 10,
      notify: [],
      departments: [],
      selectEmail: '',
      creditPanelVisible: false,
      creditRecordList: [],
      ranking: [],
      rankingUserCredit: [],
      rankingFirstDepartmentCredit: [],
      rankingDepartmentCredit: []
    }
  },
  methods: {
    formatDateLocal,
    formatDateStr,
    async handleShowCreditPanel ($event) {
      this.selectEmail = $event.currentTarget.dataset.email
      await this.fetchUserDetail()
      if (this.creditRecordList.length) {
        this.creditPanelVisible = true
      }
    },
    handleCloseCreditPanel () {
      this.selectEmail = ''
      this.creditPanelVisible = false
    },
    parseTime (time) {
      if (!time) {
        return ''
      }

      return time.replace(/T.*$/, '')
    },
    getRandomIntInclusive (min, max) {
      min = Math.ceil(min)
      max = Math.floor(max)
      return Math.floor(Math.random() * (max - min + 1)) + min // 含最大值,含最小值
    },
    initMarquee () {
      let $mq = this.$refs.notify_mq
      let $ul = this.$refs.notify_ul
      let count = this.notify.length
      // let { itemWidth, count, gap, duration, addtion } = this.wallhaven
      let w = $ul.offsetWidth
      // let left = (itemWidth + gap) * count
      let left = w
      let rule = this.getCssRule(`marquee_notify`)

      if (!rule) {
        let style = document.createElement('style')
        style.innerHTML = `@keyframes marquee_notify {}`
        document.body.appendChild(style)
        rule = this.getCssRule(`marquee_notify`)
      }

      // let widthStyle = `width:${w}px;`
      let animationStyle = `animation: marquee_notify ${(count * this.duration)}s linear infinite;`

      rule.appendRule('0% { transform: translateX(0); }')
      rule.appendRule(`100% { transform: translateX(-${left}px); }`)

      $mq.style = `${animationStyle}`
    },
    getCssRule (name) {
      let cssRule
      let rule
      let ss = document.styleSheets
      for (let i = 0; i < ss.length; ++i) {
        for (let x = 0; x < ss[i].cssRules.length; ++x) {
          rule = ss[i].cssRules[x]
          if (rule.name === name && rule.type === CSSRule.KEYFRAMES_RULE) {
            cssRule = rule
          }
        }
      }
      return cssRule
    },
    parseDate (date) {
      return {
        year: date.getFullYear(),
        month: date.getMonth() + 1
      }
    },
    getFirstDepartment (id) {
      let department
      do {
        department = this.departments.find(item => {
          return item.id === id
        })
        if (department && department.parent_id) {
          if (id === department.parent_id) {
            id = null
          } else {
            id = department.parent_id
          }
        } else {
          id = null
        }
      } while (id)

      if (!department) {
        return ''
      }

      return department.name
    },
    async getRanking () {
      let { year, month } = this.parseDate(this.now)
      let res = await API.getRanking({
        year,
        month
      })

      this.ranking = res.data
    },
    async getRankingUserCredit () {
      let res = await API.getRankingUserCredit()

      this.rankingUserCredit = res.data
      // this.rankingUserCredit = res.data.map(item => {
      //   return {
      //     email: item.email,
      //     sum: item.sum,
      //     name: item.user.name,
      //     departmentId: item.user.department_id
      //   }
      // })
    },
    async getRankingFirstDepartmentCredit () {
      let res = await API.getRankingFirstDepartmentCredit()

      this.rankingFirstDepartmentCredit = res.data
    },
    async getRankingDepartmentCredit () {
      let res = await API.getRankingDepartmentCredit()

      this.rankingDepartmentCredit = res.data
    },
    async fetchUserDetail () {
      try {
        let res = await API.graphql({
          query: `
            query {
              creditRecordList(limit: 100, user_email: "${this.selectEmail}", action: 1) {
                rows {
                  id
                  action
                  credits
                  remark
                  createdAt
                  updatedAt
                }
              }
            }
          `
        })
        this.creditRecordList = res.data.creditRecordList.rows.sort((a, b) => {
          if (a.id > b.id) {
            return -1
          } else {
            return 1
          }
        })
      } catch (err) {
        this.creditRecordList = []
      }
    },
    async fetchDepartments () {
      let res = await API.getAllDepartments()

      this.departments = res.data.rows
    },
    async fetchNotify () {
      let res = await API.getNotifyList()

      try {
        this.notify = res.data.rows
      } catch (err) {
        // NOTHING TODO
      }
    },
    async fetchData () {
      // this.getRanking()
      this.fetchDepartments()
      this.getRankingUserCredit()
      this.getRankingFirstDepartmentCredit()
      this.getRankingDepartmentCredit()
      // 暂时隐藏
      // await this.fetchNotify()

      // setTimeout(() => {
      //   this.initMarquee()
      // })
    }
  }
}
</script>

<style lang="scss" scoped>
.home {
  min-height: 100vh;
  padding-top: 320px;
  &::before {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    height: 504px;
    background: url('~@/assets/banner.png') center 0 no-repeat;
    background-size: auto 100%;
  }
}
.row {
  position: relative;
  padding: 1px 0 0;
  min-height: 100vh;
}
h2 {
  text-align: center;
  font-size: 22px;
  color: #666;
  &::before {
    content: '';
    display: inline-block;
    width: 14px;
    height: 14px;
    margin-right: 8px;
    background: #FF6022;
    border-radius: 2px;
  }
}

.notify {
  display: none;
  position: absolute;
  left: 213px;
  top: -40px;
  // width: 586px;
  width: 508px;
  height: 36px;
  line-height: 36px;
  white-space: nowrap;
  font-size: 14px;
  background: #FEFCEC;
  color: #FF6022;
  overflow: hidden;
  &::before {
    content: '';
    position: absolute;
    left: 5px;
    top: 7px;
    width: 26px;
    height: 22px;
    background: url('~@/assets/horn.png') 0 0 no-repeat;
  }
  .inner {
    margin-left: 36px;
    overflow: hidden;
  }
  ul {
    display: inline-block;
    margin: 0;
    padding: 0;
    list-style: none;
  }
  li {
    display: inline-block;
    margin: 0;
    padding: 0 60px 0 0;
    list-style: none;
  }
  em {
    font-style: normal;
  }
  .credit {
    margin: 0 10px;
  }
  .plus {
    color: #FF6022;
  }
  .reduce {
    color: #4687ED;
  }
  .time {
    color: #EFB897;
  }
}

.btn-view-detail {
  display: inline-block;
  padding: 0 24px;
  height: 24px;
  line-height: 24px;
  font-size: 12px;
  background: #F5F6FB;
  border: 1px solid #E1E4F4;
  cursor: pointer;
  &:hover {
    background: #F7F8FD;
    border-color: #EEF0FF;
    color: #AFB4D3;
  }
  &:active {
    background: #E9ECF8;
    border-color: #D4D9F2;
    color: #959AB7;
  }
}

.credit-panel {
  position: fixed;
  z-index: 10;
  left: 50%;
  top: 50%;
  // display: none;
  width: 270px;
  height: 360px;
  margin: -180px 0 0 -172px;
  background: #fff;
  box-shadow:0px 6px 20px 0px rgba(222,225,240,0.54);
  .content {
    width: 240px;
    height: 275px;
    margin: 0 auto;
    padding-top: 20px;
    overflow-y: auto;
  }
  p {
    display: flex;
    margin: 0;
    padding: 10px 0;
    font-size: 12px;
    border-bottom: 1px solid #F9F9F9;
  }
  .remark {
    width: 80px;
    line-height: 1.2;
    color: #959AB7;
  }
  .credit {
    flex: 1;
  }
  .plus {
    font-weight: 700;
    color: #FF6022;
  }
  .reduce {
    color: #4687ED;
  }
  .time {
    display: block;
    width: 70px;
    font-size: 12px;
    color: #B3B8D4;
  }
  .empty-wrap {
    padding-top: 90px;
    .icon-empty {
      display: block;
      width: 58px;
      height: 68px;
      margin: 0 auto 16px;
      background: url('~@/assets/empty.png') 0 0 no-repeat;
      background-size: 100%;
    }
    span {
      display: block;
      text-align: center;
      font-size: 14px;
      color: #B3B8D4;
    }
  }
  .ft {
    margin-top: 20px;
    .btn-close {
      display: block;
      width: 70px;
      height: 24px;
      margin: 0 auto;
      text-align: center;
      line-height: 24px;
      font-size: 12px;
      background: #4687ED;
      border-radius: 12px;
      color: #fff;
      cursor: pointer;
      &:hover {
        background: #5293FB;
      }
      &:active {
        background: #3E7EE3;
      }
    }
  }
}

.icon-num1, .icon-num2, .icon-num3 {
  display: inline-block;
  width: 20px;
  height: 24px;
}
.icon-num1 {
  background: url('~@/assets/icon_jinpai.png') center 0 no-repeat;
  background-size: auto 100%;
}
.icon-num2 {
  background: url('~@/assets/icon_yinpai.png') center 0 no-repeat;
  background-size: auto 100%;
}
.icon-num3 {
  background: url('~@/assets/icon_tongpai.png') center 0 no-repeat;
  background-size: auto 100%;
}
</style>

<style lang="scss">
.ranking {
  margin: 0 0 140px;
  box-shadow: 0px 8px 20px 0px rgba(216,220,246,0.32);
  border-radius: 0 0 10px 10px;
  .el-table__header {
    thead {
      th {
        background: #F5F6FB;
        border: none;
        color: #666;
      }
    }
  }
  tbody {
    td {
      border: none;
      color: #888;
    }
  }
}
</style>
